import { useEffect, useRef } from 'react';
import { getPreposition, getUrlParameter, replaceRouterQueryVariables } from '@portal-internet/core';
import Slider from 'components/3catinfo/Slider';
import { useModal } from 'hooks/3catinfo/useModal';
import ModalReels from 'components/3catinfo/Reels/ModalReels';
import PosterReel from 'components/3catinfo/Reels/PosterReel';
import __isEmpty from 'lodash/isEmpty';
import styles from './reels.module.scss';
import { useRouter } from 'next/router';

const codificarSlug = (url) => {
    return encodeURIComponent(url).replaceAll(/%/g, '__');
};

const descodificarSlug = (url) => {
    return decodeURIComponent(url.replace(/__/g, '%'));
};

const getTitol = (props) => {
    const { prefixTitol, titol, afegirPreposicioTitol } = props;
    if (__isEmpty(titol)) return '';
    if (__isEmpty(prefixTitol) || !afegirPreposicioTitol) return titol;
    return `${prefixTitol}${getPreposition(titol)}${titol}`;
};

const getParamsOtherReelsFromApiCall = (urlApi) => {
    return getUrlParameter(urlApi, 'frontal')
        ? `&origen=frontal&frontal=${getUrlParameter(urlApi, 'frontal')}`
        : `&origen=colleccio&id=${getUrlParameter(urlApi, 'id')}`;
};

const Reels = (props) => {
    const { items, urlDades, reelsSeccio, routerQuery } = props;
    let { reelCompartit } = props;
    const isReelCompartit =
        props.isReelCompartit &&
        replaceRouterQueryVariables(props.isReelCompartit, routerQuery) !== '{{routerQuery.shared_video}}';
    const router = useRouter();

    const paramsOtherReels = isReelCompartit
        ? replaceRouterQueryVariables(props.frontal, routerQuery)
        : getParamsOtherReelsFromApiCall(urlDades);

    const seccio = isReelCompartit ? replaceRouterQueryVariables(props.seccio, routerQuery) : router.asPath;
    const itemsModal = useRef(__isEmpty(reelsSeccio) ? items : reelsSeccio);

    const { setModal, removeModal } = useModal();
    const titol = getTitol(props);

    const handleCloseModal = () => {
        const url = seccio === '' || seccio.includes('{{') ? '/3catinfo' : seccio;
        router.push(descodificarSlug(url));

        setTimeout(() => {
            removeModal();
        }, 1500);
    };

    const handleOnClickElement = (id) => {
        setModal(<ModalReels items={itemsModal.current} idSelected={id} />, {
            onClickClose: isReelCompartit ? handleCloseModal : false,
            className: styles.reelModal,
            title: titol,
            keyDownCustom: true
        });
    };

    useEffect(() => {
        itemsModal.current = __isEmpty(reelsSeccio) ? items : reelsSeccio;

        const sharedReel = {
            seccio: codificarSlug(seccio),
            paramsOtherReels: codificarSlug(paramsOtherReels)
        };

        itemsModal.current = itemsModal.current?.map((item) => {
            item.sharedReel = sharedReel;
            return item;
        });

        if (isReelCompartit) {
            if (__isEmpty(reelCompartit)) {
                reelCompartit = {
                    id: 'no-video'
                };
            }
            const indexSharedReel = itemsModal.current?.findIndex((item) => item.id === reelCompartit.id);
            if (indexSharedReel < 0) {
                itemsModal.current = [{ ...reelCompartit, sharedReel }, ...itemsModal.current];
            }

            handleOnClickElement(reelCompartit.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.asPath]);

    return (
        <>
            {items && (
                <div className={styles.contReel}>
                    <Slider format='poster-reel' estilModul='poster-reel' titol={titol} fletxes='mig'>
                        {items?.map((item) => {
                            return (
                                <PosterReel
                                    key={`poster-reel-${item.id}`}
                                    item={item}
                                    mostraEntradeta={false}
                                    onClickElement={handleOnClickElement}
                                />
                            );
                        })}
                    </Slider>
                </div>
            )}
        </>
    );
};

Reels.defaultProps = {
    prefixTitol: '',
    afegirPreposicioTitol: true,
    isReelCompartit: false
};

export default Reels;
